import 'core-js/es6/array'
import 'core-js/es7/array'
import 'core-js/es7/string'
import * as React from 'react'
import * as ReactModal from 'react-modal'
import * as ReactDOM from 'react-dom'
import * as LogRocket from 'logrocket'
import * as Raven from 'raven-js'
import ErrorBoundary from './components/ErrorBoundary'
import * as serviceWorker from './registerServiceWorker'
import styleGlobal from './style'
import LoadablePage from 'web-makeup/dist/LoadablePage/LoadablePage'

styleGlobal()

export const requestSanitizer = request => {
  try {
    // Hide email and password from LogRocket
    const body = JSON.parse(request.body)
    if (body.variables && body.variables.password) {
      body.variables.password = null
    }
    if (body.variables && body.variables.email) {
      body.variables.email = null
    }
    request.body = JSON.stringify(body)
  } catch (err) {
    // Ignore error
  }
  if (request.headers && request.headers.Authorization) {
    request.headers.Authorization = null
  }
  return request
}

export const render = (Component, el = document.getElementById('root') as HTMLElement) => {
  if (window.env && window.env.SENTRY_DSN) {
    Raven.config(window.env.SENTRY_DSN).install()
  }

  if (window.env && window.env.APPLICATION_TAG) {
    Raven.setRelease(window.env.APPLICATION_TAG)
  }

  if (window.env && window.env.LOGROCKET_ID) {
    LogRocket.init(window.env.LOGROCKET_ID, {
      release: window.env.APPLICATION_TAG,
      network: {
        requestSanitizer,
      },
    })
  }

  if (window.analytics && window.analytics.page) {
    window.analytics.page()
  }

  ReactModal.setAppElement(el)

  ReactDOM.render(
    <ErrorBoundary>
      <Component env={window.env} />
    </ErrorBoundary>,
    el
  )
}

if (process.env.NODE_ENV !== 'test') {
  const App = LoadablePage({
    loader: () => import('./components/App' /* webpackChunkName: "App" */),
  })
  render(App)
}

if (process.env.NODE_ENV !== 'production' && (module as any).hot) {
  const mod = module as any
  mod.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default
    render(NextApp)
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()



// WEBPACK FOOTER //
// ./src/index.tsx